




















































































































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import DateFormat from '@/shared/utils/date-format';
import { DOCUMENT_MASKS } from '@/shared/utils/cnpj';
import CustomerService from '@/domain/customer/service/customer.service';
import Customer from '@/domain/customer/entity/customer.entity';
import ContractFilter from '@/domain/contract/entity/contract-filter.entity';
import ResultCenter from '@/domain/business-unit/entity/result-center.entity';
import MainButton from '@/shared/buttons/main-button.component.vue';
import BusinessUnitService from '@/domain/business-unit/service/business-unit.service';
import Response from '../../../domain/response.entity';
import EnumObject from '../../../domain/enum-object.entity';
import Pagination from '../../../domain/pagination.entity';
import CustomerOptions from './customer-options.json';

@Component({ components: { MainButton } })
export default class ContractModalFilterComponent extends Vue {
  @Prop({
    required: true,
    default: '',
  })
  private businessUnitId!: string;

  locale = 'pt-BR';

  selectedDate: Array<string> = [];

  customers: Array<Customer> = [];

  customerFetch: string = '';

  filter: ContractFilter = new ContractFilter({});

  ref: any = this.$refs;

  lastFilteredName: string = '';

  customerOptions = CustomerOptions;

  resultCenters: Array<ResultCenter> = [];

  pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 100,
    defaultSort: 'name|asc',
  })

  get customerItemText() {
    return this.filter.isTradingNameFetch
      ? 'tradingName' : 'name';
  }

  clear() {
    this.ref.form.reset();
    this.filter = new ContractFilter({});
    this.selectedDate = [];
  }

  send() {
    this.filter.status = 'ACTIVE'
    this.$emit('filter', this.filter);
  }

  private formatDate(dates: Array<string>): Array<string> {
    if (dates && dates.length === 2) {
      this.send()
      return dates.map((el: string) => DateFormat.timestampToLocal(el));
    }
    return [];
  }

  created() {
    this.getCustomers(this.customerFetch);
    this.getResultCenters();
    this.send();
  }

  getResultCenters(): void {
    BusinessUnitService.getResultCenters(this.businessUnitId)
      .then((response) => this.resultCenters = response);
  }

  getCustomers(name: string) {
    if (name && name.length >= 3 && name !== this.lastFilteredName) {
      this.lastFilteredName = name;
      CustomerService.getByTradingNameOrName(this.pagination, name,
        this.filter.selectedCustomerOption, this.businessUnitId)
        .then((response: any) => {
          this.customers = Customer.ofList(response.content)
        });
    }
  }

  get mask() {
    return DOCUMENT_MASKS;
  }
}
